<div id="ctnBox">
  <h2>{{'site.title' | translate}}</h2>
  <div id="ctnBanner">
    <img src="/assets/3column.png" alt="spritesheet 3 column"><i class="ri-arrow-left-right-line"></i><img src="/assets/4column.png" alt="spritesheet 3 column">
  </div>
  <p>{{'site.description1' | translate}} <br> {{'site.description2' | translate}} </p>
  <app-canvas></app-canvas>
</div>
